import { Defaults, Search } from "@common/_constants";
import { SeoHelper } from "@common/components/Atoms/seo";
import * as qs from "qs";

export const SearchServiceUtils = {
    queryParamsToSearchOptions: (params, emptyOptions) => {
        const options = { ...emptyOptions };
        const facetTypesByName = Object.keys(Search.FacetType).reduce((acc, typeName) => {
            const type = Search.FacetType[typeName];
            acc[type.key] = type.value;
            return acc;
        }, {});

        for (const name of Object.keys(params)) {
            if (name !== "facets" && options.hasOwnProperty(name)) {
                options[name] = params[name];
            } else if (facetTypesByName.hasOwnProperty(name)) {
                options.facets.push({
                    key: name,
                    type: facetTypesByName[name],
                    options: [{ value: params[name], selected: true }],
                });
            }
        }

        return options;
    },
    searchOptionsToQueryParams: options => {
        const allButFacets = Object.keys(options)
            .filter(k => k !== "facets")
            .reduce((acc, name) => {
                acc[name] = options[name];
                return acc;
            }, {});

        let facets = {};
        if (options.facets) {
            facets = options.facets.reduce((acc, facet) => {
                if (facet.options && facet.options.length && facet.options[0].selected) {
                    acc[facet.key] = facet.options[0].value;
                }
                return acc;
            }, {});
        }

        return { ...facets, ...allButFacets };
    },
    searchOptionsToLocation: (pathname, options) => {
        const params = SearchServiceUtils.searchOptionsToQueryParams(options);
        return {
            pathname,
            search: qs.stringify(params),
        };
    },
    searchOptionsToUrl: (options: SearchUrlOptions) => {
        const innerOptions = Object.keys(options).reduce((acc, key) => {
            if (!!options[key]) {
                acc[key] = options[key].id;
            }
            return acc;
        }, {});

        const params = SearchServiceUtils.searchOptionsToQueryParams(innerOptions);
        const search = qs.stringify(params);

        let pathname = "/";

        if (options.category) {
            pathname += SeoHelper.sani(options.category.text) + "/";
        } else {
            pathname += "ALL/";
        }

        if (options.location) {
            pathname += SeoHelper.sani(options.location.text);
        } else {
            pathname += SeoHelper.sani(Defaults.Location.AnyLocation.LOCATION_NAME);
        }

        return pathname + "?" + search;
    },
};

export interface SearchUrlOptions {
    location?: { id: number; text: string };
    category?: { id: number; text: string };
}
